// Campaign Template Reducer
import {
  GET_CAMPAIGN_TEMPLATES,
  GET_CAMPAIGN_TEMPLATES_SUCCESS,
  GET_CAMPAIGN_TEMPLATES_FAIL,
  GET_CAMPAIGN_TEMPLATES_RESET,
  GET_CAMPAIGN_TEMPLATE_BY_ID,
  GET_CAMPAIGN_TEMPLATE_BY_ID_SUCCESS,
  GET_CAMPAIGN_TEMPLATE_BY_ID_FAIL,
  GET_CAMPAIGN_TEMPLATE_BY_ID_RESET,
  SAVE_CAMPAIGN_TEMPLATE,
  SAVE_CAMPAIGN_TEMPLATE_SUCCESS,
  SAVE_CAMPAIGN_TEMPLATE_FAIL,
  SAVE_CAMPAIGN_TEMPLATE_RESET,
} from '../actions/campaignTemplateAction';

const initialState = {
  getCampaignTemplatesState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getCampaignTemplateByIdState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  saveCampaignTemplateState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const campaignTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Campaign Templates
    case GET_CAMPAIGN_TEMPLATES:
      return {
        ...state,
        getCampaignTemplatesState: {
          ...state.getCampaignTemplatesState,
          apiState: 'loading',
        },
      };
    case GET_CAMPAIGN_TEMPLATES_SUCCESS:
      return {
        ...state,
        getCampaignTemplatesState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Templates retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CAMPAIGN_TEMPLATES_FAIL:
      return {
        ...state,
        getCampaignTemplatesState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch templates',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CAMPAIGN_TEMPLATES_RESET:
      return {
        ...state,
        getCampaignTemplatesState: initialState.getCampaignTemplatesState,
      };

    // Get Campaign Template By ID
    case GET_CAMPAIGN_TEMPLATE_BY_ID:
      return {
        ...state,
        getCampaignTemplateByIdState: {
          ...state.getCampaignTemplateByIdState,
          apiState: 'loading',
        },
      };
    case GET_CAMPAIGN_TEMPLATE_BY_ID_SUCCESS:
      return {
        ...state,
        getCampaignTemplateByIdState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Template retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_CAMPAIGN_TEMPLATE_BY_ID_FAIL:
      return {
        ...state,
        getCampaignTemplateByIdState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch template',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_CAMPAIGN_TEMPLATE_BY_ID_RESET:
      return {
        ...state,
        getCampaignTemplateByIdState: initialState.getCampaignTemplateByIdState,
      };

    // Save Campaign Template
    case SAVE_CAMPAIGN_TEMPLATE:
      return {
        ...state,
        saveCampaignTemplateState: {
          ...state.saveCampaignTemplateState,
          apiState: 'loading',
        },
      };
    case SAVE_CAMPAIGN_TEMPLATE_SUCCESS:
      return {
        ...state,
        saveCampaignTemplateState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Template saved successfully',
          errors: action.response.errors || null,
        },
      };
    case SAVE_CAMPAIGN_TEMPLATE_FAIL:
      return {
        ...state,
        saveCampaignTemplateState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to save template',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case SAVE_CAMPAIGN_TEMPLATE_RESET:
      return {
        ...state,
        saveCampaignTemplateState: initialState.saveCampaignTemplateState,
      };

    default:
      return state;
  }
};

export default campaignTemplateReducer;
